import React from "react";
import BreadcrumbArea from "../../components/BreadcrumbArea/BreadcrumbArea";
import ConsultationAreaTwo from "../../components/Consultation/ConsultationAreaTwo";
import HistoryArea from "../../components/HistoryArea/HistoryArea";
import SuccessArea from "../../components/SuccessArea/SuccessArea";
import TestimonialArea from "../../components/Testimonial/TestimonialArea";
import Layout from "../../layouts/Layout";
import { Helmet } from "react-helmet";

const AboutUs = () => {
  return (
    <>
      <Helmet>
        <title>About Us – Innovatix Hub Australia</title>
        <meta
          name="description"
          content="Innovatix Hub delivers innovative graphic design solutions that elevate your brand. Discover how our expert team can bring your vision to life. Contact us today!"
        />
        <meta name="robots" content="index,follow" />
        <meta name="author" content="Innovatix Hub" />
        <meta
          property="og:title"
          content="About Us – Innovatix Hub Australia"
        />
        <meta
          property="og:description"
          content="Innovatix Hub delivers innovative graphic design solutions that elevate your brand. Discover how our expert team can bring your vision to life. Contact us today!"
        />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en_AU" />
        <meta property="og:site_name" content="Innovatix Hub AU" />
        <meta
          property="og:url"
          content="https://innovatixhub.com.au/about-us"
        />
        <meta
          property="og:image"
          content="https://innovatixhub.com.au/img/logo1.png"
        />

        <link rel="canonical" href="https://innovatixhub.com.au/about-us" />
      </Helmet>

      <Layout header={1} footer={1} className="" mainClassName="">
        <BreadcrumbArea
          title="About Us"
          subtitle={"About Us"}
          className={"pt-175 pb-60"}
        />
        <ConsultationAreaTwo />
        <SuccessArea />
        <HistoryArea />
        <TestimonialArea />
      </Layout>
    </>
  );
};

export default AboutUs;
